import { types } from 'mobx-state-tree';

export default types
  .model('MsellerListSummary', {
    id: types.number,
    login: types.string,
    mseller_url: types.string,
    location: types.string,
    date: types.string,
    activated: types.string
  })
  .views(self => ({
    get human_status() {
      return 0;
      // return shipmentStatusTranslation[self.status] || `Unknown status (${self.status})`;
    },
    get human_direction() {
      return 0;
      // return { deliver: 'Delivery', return: 'Return' }[self.direction];
    },
  }));
